fourToldApp.directive('circularBar', circularBar);

function circularBar() {
	return {
		restrict: 'E',
		scope: {
			name: '='
		},
		template: '<div ng-if="!{{name}}" align="center" class="loading">' +
			'<md-progress-circular md-mode="indeterminate"  md-diameter="60" class="md-warn md-hue-1"></md-progress-circular>' +
			'</div>'
	}
};


fourToldApp.directive('preventEnterSubmit', function () {
	return function (scope, el, attrs) {
		el.bind('keydown', function (event) {
		if (13 == event.which) {
			event.preventDefault(); // Doesn't work at all
			window.stop(); // Works in all browsers but IE...
			document.execCommand('Stop'); // Works in IE
			return false; // Don't even know why it's here. Does nothing.
			}
		});
	};
});

fourToldApp.directive('headertoggleNavbar', headertoggleNavbar);

function headertoggleNavbar() {
    return {
        restrict: 'E',
        controller: 'toggleNavbar',
        template:
            '<div ng-click="toggleNavbarOptions();$event.stopPropagation();" id="logobanner" ng-style="theme.bars">'+
                '<div flex layout="row">'+
                   '<div flex="45" layout="row" layout-align="start center">'+
                       ' <div class="fa fa-bars"></div>'+
                   '</div>'+
                   '<div flex layout="row" layout-align="start center"  ng-show="showHeader">'+
                     '<span class="md-headline">'+
                          ' <img ng-show="theme" class="contentTitleBannerResponsive"  data-ng-src="{{iconBanner}}" alt="">'+
                           '<img ng-show="!theme" class="contentTitle" data-ng-src="images/logo.png" alt="">'+
                     '</span>'+
                   '</div>'+
                '</div>'+
            '</div>'+
        '<div class="container-banner-logo imgRes" id="iconbanner" ng-show="showHeader">'+
            '<img ng-show="theme" data-ng-src="{{icon}}" alt="">'+
            '<img ng-show="!theme" data-ng-src="images/logo.png" alt="">'+
        '</div>'
    }
};

fourToldApp.directive('inputSimple', inputSimple);

function inputSimple() {
    return {
        restrict: 'E',
        template:
              '<div class="col-xs-10 col-sm-10 col-md-10 input-simple-chat">' +
              '<input type="text" class="form-control" ng-model="newMessageInput"  style="font-size:16px"  id="inputSimple" placeholder="Escribir mensaje ..." ng-keyup="$event.keyCode == 13 && sendMsg()" autocomplete="off">' +
              '</div>' +
              '<div class="col-xs-2 col-sm-1 col-md-1 input-simple-icon">' +
              '<md-icon ng-click="sendMsg();" ng-style="theme.button_send_chat" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
              '</div>'
    }
};

fourToldApp.directive('stringInput', stringInput);

function stringInput() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-10 col-sm-10 input-simple-chat">' +
              '<input type="text" class="form-control" ng-model="newMessage"  id="stringInput" style="font-size:16px" minlength="{{metadataObj.constraints.minSize}}" maxlength="{{metadataObj.constraints.maxSize}}" placeholder="Escribir mensaje ..." ng-keyup="$event.keyCode == 13 && sendMsgInputString(newMessage)" autocomplete="off">' +
              '</div>' +
              '<div class="col-xs-1 col-sm-1 input-simple-icon">' +
              '<md-icon ng-click="sendMsgInputString(newMessage)" ng-style="theme.button_send_chat" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
              '</div>'
    }
};


fourToldApp.directive('citiesInput', citiesInput);

function citiesInput() {
    return {
        restrict: 'E',
        template:
            '<div ng-controller="addressCntrl">' +
            '<div class="col-xs-10 col-sm-10 input-cities-chat"  ng-init="setFocus()">' +
            '<div ng-if="progressCircular" align="center" class="loading">' +
            '<md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60"  style="margin-top: 20%;"></md-progress-circular>' +
            '</div>' +
            '<md-container>' +
            '<md-autocomplete style="background: white; border: 1px solid #ced4da;" flex required' +
            'md-input-name="autocompleteField"' +
            'md-min-length="0"'+
            'md-max-length="2"'+
            'md-input-id="autocompleteField"' +
            'md-no-cache="false"' +
            'md-delay="100"'+
            'md-selected-item="selectedItem"' +
            'md-search-text="searchText"' +
            'md-items="item in data"' +
            'md-search-text-change="querySearch(searchText, metadataObj)"' +
            'md-item-text="item.name"' +
            'md-require-match=""' +
            'placeholder="Escribir mensaje..."' +
			'ng-model-options="{ debounce: 200 }"'+
            'input-aria-describedby="favoriteStateDescription" style="background-color: #EEEEEE;" ng-keyup="$event.keyCode == 13 && sendMsgPlace(selectedItem)">' +
            '<md-item-template>' +
            '<span md-highlight-text="searchText">{{item.fullName}}</span>' +
            '</md-item-template>' +
            '</md-autocomplete>' +
            '</md-container>' +
            '</div>' +
            '<div class="col-xs-1 col-sm-1 input-simple-icon">' +
            '<md-icon ng-click="sendMsgPlace(selectedItem)" ng-style="theme.button_send_chat" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
            '</div>'+
            '</div>'
    }
};

fourToldApp.directive('doubleInput', doubleInput);
function doubleInput() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-10 col-sm-10 input-simple-chat">' +
        '<input type="text" inputmode="decimal"   class="form-control" ng-model="newMessage"  id="doubleInput" style="font-size:16px" max="{{metadataObj.constraints.max}}" min="{{metadataObj.constraints.min}}" placeholder="Escribir mensaje ..." ng-keyup="formatDouble($event, this)" autocomplete="off">' +
        '</div>' +
        '<div class="col-xs-1 col-sm-1 input-simple-icon">' +
        '<md-icon ng-click="sendMsgInputDouble(newMessage)" ng-style="theme.button_send_chat" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
        '</div>'
    }
};

fourToldApp.directive('format', ['$filter', function ($filter) {
	return {
		require: '?ngModel',
		link: function (scope, elem, attrs, ctrl) {
			if (!ctrl) return;


			ctrl.$formatters.unshift(function (a) {
				return $filter(attrs.format)(ctrl.$modelValue)
			});


			ctrl.$parsers.unshift(function (viewValue) {
				var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
				elem.val($filter(attrs.format)(plainNumber));
				return plainNumber;
			});
		}
	};
}]);

fourToldApp.directive('stringToNumber', function() {
	return {
	  require: 'ngModel',
	  link: function(scope, element, attrs, ngModel) {
		ngModel.$parsers.push(function(value) {
		  return '' + value;
		});
		ngModel.$formatters.push(function(value) {
		  return parseFloat(value);
		});
	  }
	};
  });

fourToldApp.directive('numberInput', numberInput);

function numberInput() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-10 col-sm-10 input-simple-chat">' +
        '<input type="number"  class="form-control" ng-model="newMessage"  style="font-size:16px" max="{{metadataObj.constraints.max}}" min="{{metadataObj.constraints.min}}"  placeholder="Escribir mensaje ..." ng-keyup="$event.keyCode == 13 && newMessage!==undefined && sendMsgInputDouble(newMessage)" autocomplete="off">' +
        '</div>' +
        '<div class="col-xs-1 col-sm-1 input-simple-icon">' +
        '<md-icon ng-click="sendMsgInputDouble(newMessage)" ng-style="theme.button_send_chat" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
        '</div>'
    }
};

fourToldApp.directive('uploadImage', uploadImage);

function uploadImage() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center" >' +
			'<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" type="file" aria-label="upload" style="margin-top: 26px" ngf-select="showImagePreview($event)" ng-model="picFile" id="file" name="file" accept="image/*" ngf-max-size="5MB" required ngf-model-invalid="errorFile">' +
			'Subir Imagen' +
			'</md-button>' +
			'</div>'
	}
};

fourToldApp.directive('dateInput', dateInput);

function dateInput() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center">' +
			  '<md-button class="md-raised" style="margin-top: 26px; color: white; background: #0c78be;" ng-style="theme.button_selection_chat" aria-label="date" ng-disabled="disabledBtn" ng-click="showDatePicker($event)">' +
			  'Seleccionar Fecha' +
			  '</md-button>' +
			'</div>'+
		  '<script type="text/ng-template" id="datePicker.html">'+
			'<div class="container">'+
				'<div class="row">'+
					'<div class="col-xs-12 col-sm-8 col-md-4 col-xs-offset-0 col-sm-offset-2 col-md-offset-5">'+
						'<md-dialog style="min-width: 100%;" aria-label="Your Field Lable name">'+
								'<md-toolbar class="md-hue-3" style="color: white; background-color: #1E89D1;" ng-style="theme.button_selection_chat">'+
									'<div class="md-toolbar-tools">'+
										'<div>Seleccione la fecha</div>'+
									'</div>'+
								'</md-toolbar>'+
								'<md-dialog-content>'+
								  '<div class="md-dialog-content">'+
									'<form name="formDate" prevent-enter-submit>'+
										 '<div flex-gt-xs align="center">'+
											 '<md-datepicker name="datePicker" ng-model="current_day" id="datePicker" ng-focus="formatDate(current_day)" md-placeholder="seleccione" md-min-date="minDate" md-max-date="maxDate" md-date-filter="ctrl.disabledDays" prevent-enter-submit required></md-datepicker>'+
												'<div ng-messages="formDate.datePicker.$error">'+
													'<div ng-message= "valid">El formato requerido es DD/MM/AAAA</div>'+
													'<div ng-message= "required">Ingrese o seleccione una fecha válida</div>'+
													'<div ng-message= "mindate">La fecha ingresada no debe ser menor a {{minDate | date: "dd/MM/y"}}</div>'+
													'<div ng-message= "maxdate">La fecha ingresada no debe ser mayor a {{maxDate | date: "dd/MM/y"}}</div>'+
													'<div ng-message= "filtered">{{message_filtered}}</div>'+
											   ' </div>'+
											 '<div ng-show="messageError" style="color: red; padding-top: 2%;">{{messageError}}</div>'+
										 '</div>'+
									'</form>'+
								  '</div>'+
								'</md-dialog-content>'+
								'<md-dialog-actions style="background-color: #F1F1F1; color: white;">'+
									'<div flex layout="row">'+
										'<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
											'<md-button ng-click="ctrl.sendMsgDate(formDate.$valid)"  ng-disabled="!formDate.$valid" ng-class="{ \'disabled-conditions-button\': formDate.$invalid || formDate.datePicker.$error, \'register-form-button\': formDate.$valid}" ng-style="theme.button_send">'+
												'Enviar'+
											'</md-button>'+
										'</div>'+
										'<md-divider></md-divider>'+
										'<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
											'<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
												'Cancelar'+
											'</md-button>'+
										'</div>'+
									'</div>'+
								'</md-dialog-actions>'+
						'</md-dialog>'+
					'</div>'+
				'</div>'+
			'</div>'+
		  '</script>'
	}
};


fourToldApp.directive('timeInput', timeInput);

function timeInput() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center">' +
			  '<md-button class="md-raised" style="margin-top: 26px; color: white; background: #0c78be;"  id="timepicker" ng-style="theme.button_selection_chat" aria-label="date" ng-disabled="disabledBtn" ng-click="showTimePickerClick($event)">' +
			  'Seleccionar Hora' +
			  '</md-button>' +
			'</div>'
	}
};

fourToldApp.directive('selectSimple', selectSimple);

function selectSimple() {
	// TODO this should allow more than 2 options in select button
	return {
		restrict: 'E',
		template: '<div layout="row" layout-align="center center" class="content-bottom-select">' +
			'<md-button class="md-raised md-hue-2 col-xs-5 col-sm-6 col-md-6 col-lg-3 fontSizeButton" style="color: white; background: #0c78be;" ng-style="theme.button_selection_chat" aria-label="Close" ng-click="sendMsgSelect(metadataObj.constraints.options[0])" ng-show="metadataObj.constraints.options[0]">{{metadataObj.constraints.options[0].value}}</md-button>' +
			'<md-button class="md-raised md-hue-2 col-xs-5 col-sm-6 col-md-6 col-lg-3 fontSizeButton" style="color: white; background: #0c78be;" ng-style="theme.button_selection_chat" aria-label="Close" ng-click="sendMsgSelect(metadataObj.constraints.options[1])" ng-show="metadataObj.constraints.options[1]">{{metadataObj.constraints.options[1].value}}</md-button>' +
			'</div>'

	}
};

fourToldApp.directive('selectList', selectList);

function selectList() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center">' +
			'<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" aria-label="option" ng-disabled="disabledBtn" style="margin-top: 26px" ng-click="showConfirm($event)" >' +
			'Ver opciones' +
			'</md-button>' +
			'</div>'+
			'<script type="text/ng-template" id="selectList.html">'+
			'<div class="container">'+
			  '<div class="row" layout-align="start center">'+
				  '<div class="col-xs-12 col-sm-8 col-md-6 col-xs-offset-2 col-sm-offset-4 col-md-offset-4">'+
					  '<md-dialog>'+
						  '<div ng-if="progressCircular" align="center" class="loading">'+
							  '<md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
						  '</div>'+
						  '<form ng-cloak>'+
							  '<md-toolbar class="md-hue-3" style="color: white; background-color: #1E89D1;" ng-style="theme.button_selection_chat">'+
								  '<div class="md-toolbar-tools">'+
									  '<div>{{title}}</div>'+
								  '</div>'+
								  '<md-input-container class="search-list" md-no-float class="md-block" ng-show="optionList.constraints.searchable && optionList.constraints.searchable === true">'+
									'<input type="search" class="empty" name="search" ng-model="search" placeholder="Buscar... &#xF002;" aria-label="search" autocomplete="off"  ng-keyup="pressKey()">'+
								  '</md-input-container>'+
							  '</md-toolbar>'+
							  '<md-dialog-content>'+
								  '<div class="md-dialog-content" style="padding: 0px;">'+
									  '<div style="max-height: calc(100vh - 200px);">'+
										  '<md-list flex style="padding: 0px;" ng-if="showList">'+
											  '<md-list-item class="md-3-line" ng-repeat="item in optionList.constraints.options | filter:search"  ng-click="sendMsgList(item, optionList.constraints.labelsSource)">'+
												  '<div class="md-list-item-text" layout="column">'+
													  '<md-divider ng-if="!$last"></md-divider>'+
													  '<h3 style="white-space: normal;">{{ item.value }}</h3>'+
												  '</div>'+
											  '</md-list-item>'+
										  '</md-list>'+
									  '</div>'+
								  '</div>'+
							  '</md-dialog-content>'+
							  '<md-dialog-actions style="background-color: #F1F1F1; color: white; border-top: 1px solid lightgrey;">'+
								  '<div class="row">'+
									  '<div class="col-xs-5 col-sm-5">'+
										  '<md-button ng-click="closeDialog()" class="md-warn">'+
											  'Cancelar'+
										  '</md-button>'+
									  '</div>'+
								  '</div>'+
							  '</md-dialog-actions>'+
						  '</form>'+
					  '</md-dialog>'+
				'  </div>'+
			  '</div>'+
		  '</div>'+
		'</script>'
	}
};

fourToldApp.directive('selectListCheckbox', selectListCheckbox);

function selectListCheckbox() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center">' +
			'<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" aria-label="option" ng-disabled="disabledBtn" style="margin-top: 26px" ng-click="listCheckbox($event)" >' +
			'Ver opciones' +
			'</md-button>' +
			'</div>'+
			'<script type="text/ng-template" id="selectListMultiple.html">'+
			  '<div class="container">'+
				  '<div class="row">'+
					  '<div class="col-xs-12 col-sm-8 col-md-4 col-xs-offset-0 col-sm-offset-2 col-md-offset-5">'+
						  '<md-dialog style="max-width: 100%; min-width: 100%;">'+
							  '<form ng-cloak>'+
								'<md-toolbar class="md-hue-3" style="color: white; background-color: #1E89D1;" ng-style="theme.button_selection_chat">'+
									'<div class="md-toolbar-tools">'+
										'<div>Selecciona una o varias opciones</div>'+
									'</div>'+
									'<md-input-container class="search-list" md-no-float class="md-block" ng-show="optionList.constraints.searchable && optionList.constraints.searchable === true">'+
									  '<input type="text" class="empty" name="search" ng-model="search" placeholder="Buscar... &#xF002;" aria-label="search" autocomplete="off">'+
									'</md-input-container>'+
								'</md-toolbar>'+
								  '<md-dialog-content>'+
									  '<div class="md-dialog-content">'+
										  '<div style="max-height: calc(100vh - 300px);">'+
											  '<div layout="row" layout-wrap flex>'+
												  '<div flex="100" ng-model="selectedItem" ng-repeat="item in optionList.constraints.options | search:search">'+
													  '<md-checkbox ng-checked="exists(item, selected)" ng-click="toggle(item, selected)">'+
														  '{{ item.value }}'+
													  '</md-checkbox>'+
												  '</div>'+
											  '</div>'+
										  '</div>'+
									  '</div>'+
								  '</md-dialog-content>'+
								  '<md-dialog-actions style="background-color: #F1F1F1; color: white;">'+
									  '<div flex layout="row">'+
										  '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
											  '<md-button class="md-primary" ng-click="sendMsgListCheckbox(selected)" ng-disabled="!selectedItem">'+
												  'Enviar'+
											  '</md-button>'+
										  '</div>'+
										  '<md-divider></md-divider>'+
										  '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
											  '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
												  'Cancelar'+
											  '</md-button>'+
										  '</div>'+
									  '</div>'+
								  '</md-dialog-actions>'+
							  '</form>'+
						  '</md-dialog>'+
					  '</div>'+
				  '</div>'+
			  '</div>'+
			'</script>'
	}
};

fourToldApp.directive('uploadPhoto', uploadPhoto);

function uploadPhoto() {
    return {
        restrict: 'E',
        template:
            '<div ng-if="metadataObj.constraints.fromGallery === true">'+
              '<div class="col-xs-6 col-md-6 col-lg-6" align="center">' +
              '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" aria-label="option" ng-disabled="disabledBtn" style="margin-top: 26px" ng-click="validateBarcode($event, metadataObj.constraints.imageType)">' + /*ng-click="listCheckbox($event)" */
              'Habilitar camara' +
              '</md-button>' +
              '</div>' +
              '<div class="col-xs-6 col-md-6 col-lg-6" align="center">' +
              '<md-button  class="chatButton md-block" ng-style="theme.button_selection_chat" ng-disabled="disabledBtn" type="button"  aria-label="upload" style="margin-top: 26px" id="btnFile" ng-click="shouldShowHelp()">' +
              'Buscar Imagen' +
              '</md-button>' +
              '<md-button ng-show="false" class="chatButton md-block" ng-style="theme.button_selection_chat" type="file"  aria-label="upload" style="margin-top: 26px" ngf-select="showImagePreview($event)" ng-model="picFile" id="file" name="file" accept="image/*" ngf-max-size="5MB" required ngf-model-invalid="errorFile">' +
              'Buscar Imagen' +
              '</md-button>' +
              '</div>'+
            '</div>'+
            '<div ng-if="metadataObj.constraints.fromGallery !== true">'+
              '<div class="col-xs-12 col-md-12 col-lg-12" align="center">' +
              '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" aria-label="option" ng-disabled="disabledBtn" style="margin-top: 26px" ng-click="validateBarcode($event, metadataObj.constraints.imageType)">' + /*ng-click="listCheckbox($event)" */
              'Habilitar camara' +
              '</md-button>' +
              '</div>' +
            '</div>'+
            '<script type="text/ng-template" id="imagePreview.html">'+
            '<div class="row">' +
                '<div class="col-xs-12 col-md-12 col-xs-offset-0 col-md-offset-3">'+
                    '<md-dialog style="max-width: 100%;" aria-label="dialog">'+
                        '<div ng-if="progressCircular" align="center" class="loading">'+
                          '  <md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
                        '</div>'+
                        '<form ng-cloak>'+
                            '<md-toolbar class="md-hue-3" style="color: white; background-color:#1E89D1;" ng-style="theme.button_selection_chat">'+
                                '<div class="md-toolbar-tools">'+
                                  '  <div class="row">'+
                                        '<div class="col-xs-12 col-md-12">'+
                                          '  <span>Imagen Seleccionada</span>'+
                                        '</div>'+
                                    '</div>'+
                                '</div>'+
                            '</md-toolbar>'+
                            '<md-dialog-content>'+
                                '<div class="md-dialog-content">'+
                                    '<div class="row">'+
                                        '<div style="max-height: calc(100vh - 200px); overflow-y: auto; ">'+
                                            '<div class="col-xs-12 col-md-12" align="center">'+
                                                '<img style="max-width: 200px;padding-bottom: 10px; padding-top: 10px; border: none" ngf-src="picFile" class="thumbnail">'+
                                            '</div>'+
                                      '  </div>'+
                                    '</div>'+
                              '  </div>'+
                            '</md-dialog-content>'+
                          '  <md-dialog-actions style="background-color: #F1F1F1; color: white;">'+
                                '<div flex layout="row">'+
                                    '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
                                        '<md-button ng-click="sendMsgImg(picFile)"  ng-class="{\'register-form-button\': !theme.button_send_background_color}" ng-style="theme.button_send">'+
                                          '  Enviar'+
                                        '</md-button>'+
                                    '</div>'+
                                  '  <md-divider></md-divider>'+
                                    '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
                                        '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
                                            'Cancelar'+
                                        '</md-button>'+
                                    '</div>'+
                                '</div>'+
                            '</md-dialog-actions>'+
                        '</form>'+
                    '</md-dialog>'+
                '</div>'+
            '</div>'+
          '</script>'
    }
};

fourToldApp.directive('uploadFile', uploadFile);

function uploadFile() {
	return {
		restrict: 'E',
		template: '<div class="col-xs-12 col-md-12" align="center">' +
			'<md-button class="chatButton md-block" ng-style="theme.button_selection_chat" type="file" aria-label="upload" style="margin-top: 26px" ngf-select="uploadFiles($event)" ng-init="checkTypeFile(metadataObj)" ng-model="docFile" id="file" name="file" accept="{{file}}" ngf-max-size="5MB" required ngf-model-invalid="errorFile">' +
			'Seleccionar Archivo' +
			'</md-button>' +
			'</div>'
	}
};

fourToldApp.directive('myDirective', function($http, $templateCache, $compile) {
  return {
	scope: {
	  data: '=myDirectiveData'
	},
	link: function(scope, elm, attrs) {
	  console.log(scope);
	  console.log(elm);
	  console.log(attrs.template);
	  $http.get('../../views/dashboard/'+attrs.template).then(function (response) {
		   $templateCache.put('template.html', response.data);
		   //console.log($templateCache.get('pl2.html'));
	   }, function (errorResponse) {
		   console.log('Cannot load the file template');
	   });
	}
  };
});

fourToldApp.directive("scroll", function ($window) {
	return function(scope, element, attrs) {
		angular.element($window).bind("scroll", function() {
			if (this.pageYOffset >= 100) {
				 scope.boolChangeClass = true;
				 console.log('Scrolled below header.');
			 } else {
				 scope.boolChangeClass = false;
				 console.log('top');
			 }
			scope.$apply();
		});
	};
});

fourToldApp.directive('scroll2', function() {
  return{
	  link: function(scope, element, attr) {
	  element.on('scroll', function() {
		if(element[0].scrollTop <= 0){
		  scope.$emit('go');
		}
	  });
	}
  }
});

fourToldApp.directive('carouselControls', function() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.goNext = function() {
          element.isolateScope().next();
        };
        scope.goPrev = function() {
          element.isolateScope().prev();
        };

      }
    };
  });

fourToldApp.directive('guarantorProposal', function() {
	return {
		restrict: 'E',
		template: 
		'<div style="padding-left:2%;"><img style="height: 30px; width: 30px; color: #737373;" alt="logo" title="Haz click para volver atrás" onerror="this.onerror=null;this.src=\'images/icons/keyboard_backspace-24px.svg\';" data-ng-src="images/icons/keyboard_backspace-24px.svg" ng-click="goBack()"></div>' +
		'<div style="max-width: 100%;" class="md-whiteframe-3dp-borrower">'+
		'<div class="client-column" style="padding:1%;">' +
		'<div class="row">' +
		'  <div class="col-sm-1 col-xs-3">' +
		'    <img style="height: 60px; width: 60px; border-radius: 50%; border:3px solid #FFFFFF;" alt="logo"  onerror="this.onerror=null;this.src=\'images/default-profile-image.png\';" data-ng-src="images/avatar.png">' +
		'  </div>' +
		'  <div class="col-sm-8 col-xs-9">' +
		'    <p style="color:#949494;">{{data_item_pending.borrower.entity.firstName}} {{data_item_pending.borrower.entity.lastName}}</p>' +
		'    <p style="color:#317668;">Estado: {{data_item_pending.status}}</p>' +
		'  </div>' +
		'</div>' +
		'</div>' +
		'<md-divider></md-divider>'+
		'<div style="color: #4eaec5; padding:1%;">' +
		'<h4>Número de Crédito: {{data_item_pending.loan.id}}</h4>' +
		'</div>' +
		'<section>'+
		'<div style="color: #707070; padding:2%; padding-top:0px;">'+
		'<div layout="row">'+
		'    <div flex="70">'+
		'        <span><img class="guarantor-icons" ng-src="../images/iconsChat/loancredit.png" /></span>'+
		'        <span>Monto a Garantizar</span>'+
		'    </div>'+
		'    <div flex="" layout="row" layout-align="end center">'+
		'        <span style="float: right;">{{data_item_pending.proposalRequest.guaranteedAmount | currency}}</span>'+
		'    </div>'+
		'</div>'+
		'<div layout="row">'+
		'    <div flex="70">'+
		'        <span><img class="guarantor-icons" ng-src="../images/iconsChat/wallet.png" /></span>'+
		'        <span>Ganancia por crédito pagado</span>'+
		'    </div>'+
		'    <div flex="" layout="row" layout-align="end center">'+
		'        <span style="float: right;">{{data_item_pending.proposalRequest.amountGain | currency:undefined:0}}</span>'+
		'    </div>'+
		'</div>'+
		'<div style="color: #2f775e;">Compromiso de pago por falla de crédito</div>'+
		'<div layout="row">'+
		'    <div flex="70">'+
		'        <span><img class="guarantor-icons" ng-src="../images/iconsChat/interest.png" /></span>'+
		'        <span>Tasa de interés</span>'+
		'    </div>'+
		'    <div flex="" layout="row" layout-align="end center">'+
		'        <span style="float: right;">{{data_item_pending.proposalRequest.interest}}</span>'+
		'    </div>'+
		'</div>'+
		'<div layout="row">'+
		'    <div flex="70">'+
		'        <span><img class="guarantor-icons" ng-src="../images/iconsChat/latefee.png" /></span>'+
		'        <span>Monto a pagar</span>'+
		'    </div>'+
		'    <div flex="" layout="row" layout-align="end center">'+
		'        <span style="float: right;">{{data_item_pending.proposalRequest.guaranteedAmount | currency}} + Intereses</span>'+
		'    </div>'+
		'</div>'+
		'</div>'+
		'<md-divider></md-divider>'+
		'<aside style="color: #707070; padding-left: 24px; padding: 1%;">'+
		'<div layout="row">'+
		'    <div class="flexTitle">'+
		'        <img class="guarantor-icons guarantor-icons-background" alt="credito"'+
		'            ng-src="../images/iconsChat/loanselection.png" />'+
		'    </div>'+
		'    <div flex="50" style="padding-top: 1%;">'+
		'        <div flex>'+
		'            <div class="demo-swipe">'+
		'                <span>'+
		'                    {{data_item_pending.borrower.entity.firstName}} {{data_item_pending.borrower.entity.lastName}}'+
		'                </span>'+
		'            </div>'+
		'            <div class="demo-swipe">'+
		'                <span style="color: #2f775e;">'+
		'                    Crédito original por garantizar'+
		'               </span>'+
		'            </div>'+
		'        </div>'+
		'    </div>'+
		'    <div flex="">'+
		'       <span ng-class=\'toggle ? "fa fa-chevron-up" : "fa fa-chevron-down"\' style="font-size: 15px; color: #737373; float: right;" ng-click="moreInformation(toggle); toggle = !toggle"></span>'+
		'    </div>'+
		'</div>'+
		'</aside>'+
		'<md-divider></md-divider>'+
		'<aside ng-if="toggle" class="md-dialog-content-guarantor">'+
		'<div style="color: #707070;">'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/loancredit.png" /></span>'+
		'            <span>Costo total del crédito</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center" style="background-color: #1077BA; color: white; margin-left: 50px; padding:1%;">'+
		'            <span style="float: right;"'+
		'                ng-init="totalLoanFees(data_item_pending.loan.loanFees)">{{data_item_pending.proposal.capitalAmount  +  totalFees + data_item_pending.proposal.interestAmount | currency:data_item_pending.loan.prefixCurrency}} {{data_item_pending.loan.suffixCurrency}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/opendate.png" /></span>'+
		'            <span>Fecha del crédito</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center">'+
		'            <span style="float: right;">{{data_item_pending.proposal.createDate | date: "MM/dd/y"}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/interest.png" /></span>'+
		'            <span>Crédito otorgado</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center" style=" background-color:#50B396; color: white; margin-left: 50px; padding:1%;">'+
		'            <span style="float: right;">{{data_item_pending.proposal.capitalAmount | currency:data_item_pending.loan.prefixCurrency}} {{data_item_pending.loan.suffixCurrency}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/amount.png" /></span>'+
		'            <span>Cuota de pago</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center">'+
		'            <span style="float: right;">{{data_item_pending.proposal.paymentAmount | currency:data_item_pending.loan.prefixCurrency}} {{data_item_pending.loan.suffixCurrency}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/amount.png" /></span>'+
		'            <span>Monto de interés</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center">'+
		'            <span style="float: right; color:#449879;">{{data_item_pending.proposal.interestAmount}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/amount.png" /></span>'+
		'            <span>Cuotas</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center">'+
		'            <span style="float: right;">{{data_item_pending.proposal.duration}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div layout="row">'+
		'        <div flex="70">'+
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/periocity.png" /></span>'+
		'            <span>Periodicidad</span>'+
		'        </div>'+
		'        <div flex="" layout="row" layout-align="end center">'+
		'            <span style="float: right;">{{periocity(data_item_pending.loan.periodicity)}}</span>'+
		'        </div>'+
		'    </div>'+
		'    <div ng-repeat="loan in data_item_pending.loan.loanFees track by $index"'+
		'        style="padding-top: 2%; padding-left: 2%; padding-bottom: 2%;">'+
		'        <span>{{loan.description}}</span>'+
		'        <span style="float: right;">{{loan.amount | currency:data_item_pending.loan.prefixCurrency}} {{data_item_pending.loan.suffixCurrency}}</span>'+
		'    </div>'+
		' </div>'+
		'</aside>'+
		'<aside layout="row" layout-align="center center" style="padding:1%;" ng-if="data_item_pending.proposalRequest.status === \'PROPOSED\'">'+
		'      <md-button class="md-warn" ng-click="guarantor_response_proposal(data_item_pending.proposal.loanId, \'REJECTED\')">'+
		'          Rechazar Crédito'+
		'      </md-button>'+
		'      <md-button class="md-primary" ng-click="guarantor_response_proposal(data_item_pending.proposal.loanId, \'ACCEPTED\')">'+
		'          Acepto'+
		'      </md-button>'+
		'</aside>'+
		'</section>'+
		'</div>'
	};
}); 

fourToldApp.directive('guarantorActiveLoan', function() {
	return {
		restrict: 'E',
		template:
		'<div style="padding-left:2%;"><img style="height: 30px; width: 30px; color: #737373;" alt="logo" title="Haz click para volver atrás" onerror="this.onerror=null;this.src=\'images/icons/keyboard_backspace-24px.svg\';" data-ng-src="images/icons/keyboard_backspace-24px.svg" ng-click="goBack()"></div>' +
		'<div style="max-width: 100%;" class="md-whiteframe-3dp-borrower">' +
		'<div class="client-column" style="padding:1%;">' +
		'<div class="row">' +
		'  <div class="col-sm-1 col-xs-3">' +
		'    <img style="height: 60px; width: 60px; border-radius: 50%; border:3px solid #FFFFFF;" alt="logo"  onerror="this.onerror=null;this.src=\'images/default-profile-image.png\';" data-ng-src="images/avatar.png">' +
		'  </div>' +
		'  <div class="col-sm-8 col-xs-9">' +
		'    <p style="color:#949494;">{{data_item_active.borrower.entity.firstName}} {{data_item_active.borrower.entity.lastName}}</p>' +
		'    <p style="color:#317668;">Estado: {{data_item_active.status}}</p>' +
		'  </div>' +
		'</div>' +
		'</div>' +
		'<md-divider></md-divider>' +
		'<div style="color: #4eaec5; padding:1%;">' +
		'<h4>Número de Crédito: {{data_item_active.loan.id}}</h4>' +
		'</div>' +
		'<section class="md-dialog-content-guarantor" style="color: #707070;">' +
		'	<div layout="row">' +
		'        <div flex="70">' +
		'            <span><img class="guarantor-icons" ng-src="../images/iconsChat/loancredit.png" /></span>' +
		'            <span>Monto a Garantizar</span>' +
		'         </div>' +
		'          <div flex="" layout="row" layout-align="end center">' +
		'             <span style="float: right;">{{data_item_active.proposalRequest.guaranteedAmount | currency}}</span>' +
		'          </div>' +
		'   </div>' +
		'   <div layout="row">'+
		'      <div flex="70">'+
		'          <span><img class="guarantor-icons" ng-src="../images/iconsChat/wallet.png" /></span>'+
		'          <span>Ganancia por crédito pagado</span>'+
		'       </div>'+
		'       <div flex="" layout="row" layout-align="end center">'+
		'           <span style="float: right;">{{data_item_active.proposalRequest.amountGain | currency}}</span>'+
		'        </div>'+
		'   </div>'+
		'	<div ng-if="data_item_active.loan.loanDetails.amortizationPlan  && data_item_active.loan.loanDetails.amortizationPlan.plan">'+
		'		<div style="color: #3DACCA;">Seguimiento de pagos</div>'+
		'		<div layout="row">'+
		'			<div flex="70">'+
		'				<span><img class="guarantor-icons-accept-cancel" ng-src="../images/iconsChat/greencheck.png" /></span>'+
		'				<span>Número de pagos realizados:</span>'+
		'			</div>'+
		'			<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right; color: #2f775e;">{{data_item_active.loan.loanDetails.paymentsDone}}  /  {{data_item_active.loan.duration}}</span>'+
		'			</div>'+
		'		</div>'+
		'		<div layout="row" ng-init="countDelayedPlans(data_item_active.loan.loanDetails.amortizationPlan)">'+
		'			<div flex="70">'+
		'				<span><img class="guarantor-icons-accept-cancel" ng-src="../images/iconsChat/reject.png" /></span>'+
		'				<span>Retraso (días):</span>'+
		'			</div>'+
		'			<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right; color: #842626;">{{delayedDays}}</span>'+
		'			</div>'+
		'		</div>'+
		'		<div layout="row" ng-if="delayedDays > 0">'+
		'			<div flex="70">'+
		'				<span><img class="guarantor-icons" ng-src="../images/iconsChat/reject.png" /></span>'+
		'				<span>Intereses de mora:</span>'+
		'			</div>'+
		'			<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right; color: #842626;">{{delayInterest}}</span>'+
		'			</div>'+
		'		</div>'+
		'		<div style="padding: 2%;">'+
		'			<div layout="row">'+
		'				<div flex="70">'+
		'				<span style="color: #6AB4A3;">{{data_item_active.loan.loanDetails.totalPaid | currency: undefined:0}}</span>'+
		'				</div>'+
		'				<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right;">{{data_item_active.loan.loanDetails.totalDue | currency: undefined:0}}</span>'+
		'				</div>'+
		'			</div>'+
		'			<div class="progress" ng-init="getPercentage(data_item_active.loan.loanDetails)">'+
		'				<div class="progress-bar" role="progressbar" style="{width : ( percentage + \'%\' ) }" aria-valuenow="{{percentage}}" aria-valuemin="0" aria-valuemax="100"></div>'+
		'			</div>'+
		'			<div layout="row">'+
		'				<div flex="70">'+
		'				<span style="color: #6AB4A3;">Pagado</span>'+
		'				</div>'+
		'				<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right;">Balance</span>'+
		'				</div>'+
		'			</div>'+
		'		</div>'+
		'		<div layout="row">'+
		'			<div flex="70">'+
		'				<span><img class="guarantor-icons" ng-src="../images/iconsChat/amount.png" /></span>'+
		'				<span>Monto de pagos:</span>'+
		'			</div>'+
		'			<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right; color: #3DACCA;">{{data_item_active.loan.loanDetails.pendingPayment + data_item_active.loan.loanDetails.nextPayment | currency}}</span>'+
		'			</div>'+
		'		</div>'+
		'		<div layout="row">'+
		'			<div flex="70">'+
		'				<span><img class="guarantor-icons" ng-src="../images/iconsChat/amount.png" /></span>'+
		'				<span>Número de cuotas restantes:</span>'+
		'			</div>'+
		'			<div flex="" layout="row" layout-align="end center">'+
		'				<span style="float: right;">{{data_item_active.loan.duration - data_item_active.loan.loanDetails.paymentsDone}}</span>'+
		'			</div>'+
		'		</div>'+
		'		<div ng-repeat="loan in data_item_active.loan.loanFees track by $index"'+
		'        	style="padding-top: 2%; padding-left: 2%; padding-bottom: 2%;">'+
		'       	<span>{{loan.description}}</span>'+
		'        	<span style="float: right;">{{loan.amount | currency}}</span>'+
		'    	</div>'+
		'	</div>'+
		'</section>' +
		'</div>'
	}
});

fourToldApp.directive('autocompleteInput', autocompleteInput);

function autocompleteInput() {
    return {
        restrict: 'E',
        controller: 'addressCntrl',
        template:
        '<script type="text/javascript">'+
		'var timeout = null;'+
		'function doDelayedSearch() {'+
		' if (timeout) {  '+
		'	clearTimeout(timeout);'+
		'  }'+
		' timeout = setTimeout(function() {'+
		'searchfunction()'+
		' }, 500);'+
		'}'+
		''+

        ' var searchfunction = function() {'+
        '  angular.element(document.getElementById("autocompleted")).scope().querySearch(document.getElementById("autocompleted").value,null)'+
         '};'+
        '</script>'+
        '<div class="form-group col-xs-10 col-sm-10 col-md-10 input-simple-chat dropup">'+
        '<input class="form-control" id="autocompleted" ng-model="searchText" ng-model-options="{ debounce: 600 }" oninput="doDelayedSearch()" autocomplete="off" placeholder="Buscar..." type="text"  ng-keyup="$event.keyCode == 13 && searchText && sendMsgPlace(selectedItem)" >'+
        '<ul id="ulAutocomplete" class="dropup-content">'+
        '<li ng-show="!selectedItem  && showListText" ng-repeat="data in request"><a href="" ng-click="selectOption(data)">{{data.fullName}}</a></li>'+
        '</ul>'+
        '</div>'+
        '<div class="col-xs-2 col-sm-1 col-md-1 input-simple-icon">' +
        '<md-icon ng-click="sendMsgPlace(selectedItem)" class="icon-send-chat-message" md-svg-src="images/icons/baseline-send-24px.svg"></md-icon>' +
        '</div>'
    }

};

fourToldApp.directive('autocompleteformInput', autocompleteformInput);

function autocompleteformInput() {
    return {
        restrict: 'E',
        scope:{
            bodyItem: '=',
            notificationform: '=',
            index: '@',
            error: '=',
			chat: '='
        },
        controller: 'addressFormCntrl',
        template:        
        
            
            '<div class="form-group compress-desin-group">' +
            '   <label for="inputNameLabel" class="col-sm-12 col-md-5 control-label compress-desing" ng-bind-html="bodyItem.label"></label>' +
            '   <div class="col-sm-12 col-md-7 dropup">' +
            '   <input required class="form-control" id="autocompleted{{index}}" name="autocompleted{{index}}" ng-readonly="read" ng-model="bodyItem.metadata.defaultValue" ng-model-options="{ debounce: 500 }" ng-change="querySearch(bodyItem.metadata.defaultValue, bodyItem.metadata.constraints, index)" autocomplete="off" placeholder="Buscar..." type="text"  ng-keyup="$event.keyCode == 13 && searchText && sendMsgPlace(selectedItem.name)" >'+
           

            
            '   <div ng-messages="notificationform[\'autocompleted\' + index].$error" style="color:maroon" role="alert">'+
            '       <div ng-message="required"><span ng-if="!bodyItem.metadata.constraints.required">Introduzca un valor para este campo</span><span>{{bodyItem.metadata.constraints.required}}</span></div>'+
            '   </div>' +
            '   </div>' +
         
						

        
        '   <ul ng-show="!selectedItem  && showListText"  id="ulAutocomplete{{index}}" class="dropup-content">'+
        '   <li ng-repeat="data in request"><a href="" ng-click="selectOption(data, bodyItem.metadata.constraints.valueType)">{{data.fullName}}</a></li>'+
        '   </ul>' 
    }

};


fourToldApp.directive('selectInput', selectInput);
function selectInput () {
    return{
        restrict:'E',
        template:
        '<md-card style="overflow-x: auto">'+
        '<md-card-header ng-show="bodyItem.metadata.sectionTitle">'+
        '<md-card-header-text style="padding-left:3%;">'+
        '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>'+
        '</md-card-header-text>'+
        '<md-card-icon-actions>'+
        '<md-button  ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle" aria-label="Close">'+
        '<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
        '<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg"></md-icon>'+
        '</md-button>'+
        '</md-card-icon-actions>'+
        '</md-card-header>'+
        '<md-card-content class="input-container" ng-show="!bodyItem.metadata.isExpandable">' +
        '<label  style="margin-left: 10px" ng-bind-html="bodyItem.label"></label>' +
        '<div ng-if="bodyItem.metadata.images.length===1" class="row" ng-repeat="image in bodyItem.metadata.images" align="left" style="margin-top: 20px; margin-bottom: 20px">' +
        '<img ng-src="{{esb}}/security{{image.url}}" class="col-xs-offset-1 col-xs-12 col-sm-offset-0" style="max-width: 270px; ">' +
        '</div>' +
        '<div ng-if="bodyItem.metadata.images.length>1" layout="row" layout-align="start center"' +
        ' layout-align="center center" class="scrollbar-default"  style="padding-bottom: 10px; overflow-x: auto" >' +
        '<div id="imageModal" class="image-modal" ng-click="closeModal();  $event.stopPropagation();">' +
        '  <span class="close-modal" ng-click="closeModal()">&times;</span>' +
        '  <img class="modal-content" id="zoomedImage" >' +
        '</div>' +
        '<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url!==null" style="margin-left: 20px">' +
        '<img ng-click="imagePreview(image.url)" ng-src="{{esb}}/security{{image.url}}" style="min-width: 270px; max-width: 270px; ">' +
        '</span>' +
        '<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url===null" style="margin-left: 20px">' +
        '<img ng-src="images/default-profile-image.png" style="min-width: 270px; max-width: 270px; ">' +
        '</span>' +
        ' </div>' +
        '<hr ng-if="bodyItem.metadata.images.length>1 || bodyItem.metadata.images.length===1">' +
        '<div class="md-block select-container">' +
        '<div ng-init="evalSelectDefault($index,bodyItem.metadata.defaultValue,bodyItem.metadata.constraints.options)"></div>' +
        '<div ng-repeat="option in bodyItem.metadata.constraints.options">' +
        '    <input type="radio" id="{{bodyItem.targetField}}_{{$index}}" ng-model="bodyItem.metadata.defaultValue" ng-readonly="read" ng-value="option.id" required/> <label for="{{bodyItem.targetField}}_{{$index}}" style="font-weight: normal">{{option.value}}</label>' +
        '</div>'+
        '</div>' +
        '</md-card-content>'+
        '</md-card>'
    }
};

fourToldApp.directive('htmlInfo', htmlInfo);
function htmlInfo () {
    return{
        restrict:'E',
        template:
		'<md-content style="overflow-x: auto">'+
		'<div ng-if="bodyItem.metadata.sectionTitle">'+
		'	<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>'+
		'	<md-button  ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle" aria-label="Close">'+
        '		<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
        '		<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg"></md-icon>'+
        '	</md-button>'+
		'</div>'+
		'<div ng-if="!bodyItem.metadata.isExpandable">'+
        '	<ng-bind-html ng-bind-html=renderHtml(bodyItem.label)></ng-bind-html>' +
        '	<div ng-if="bodyItem.metadata.images.length>0" layout="row" layout-align="start center"' +
        ' 	layout-align="center center" class="scrollbar-default"  style="padding-bottom: 10px; overflow-x: auto" >' +
        '		<div id="imageModal" class="image-modal" ng-click="closeModal();  $event.stopPropagation();">' +
        ' 			<span class="close-modal"  ng-click="closeModal()">&times;</span>' +
        '  			<span class="close-modal"  style="right: 70px" ng-click="zoomOutModal();$event.stopPropagation();">-</span>' +
        '  			<span class="close-modal"  style="right: 100px" ng-click="zoomInModal();$event.stopPropagation();">+</span>' +
        '  			<span class="close-modal"  style="right: 135px"><a id="imageLink"><img src="../images/iconsChat/download.png" style="width:30px; height:30px"><a/></span>' +
        '  			<iframe id="downloadFrame" style="display:none;"></iframe>' +
        '  			<img class="modal-content" id="zoomedImage" >' +
        '		</div>' +
        '		<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url!==null" style="margin-left: 20px">' +
        '			<img ng-click="imagePreview(image.url)" ng-src="{{esb}}/security{{image.url}}" style="min-width: 270px; max-width: 270px; ">' +
        '		</span>' +
        '		<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url===null" style="margin-left: 20px">' +
        '			<img ng-src="images/default-profile-image.png" style="min-width: 270px; max-width: 270px; ">' +
        '		</span>' +
        '	</div>' +
        '</div>' +
		'</div>'
    }
};
fourToldApp.directive('htmlInfoField', htmlInfoField);
function htmlInfoField () {
	return{
		restrict:'E',
		template:
			'<div class="form-group">'+
			'<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
			'<div class="col-md-7" style="padding-top: 7px !important; margin-bottom: 0 !important;">'+
			'<span class="control-label">{{bodyItem.metadata.defaultValue}}</span>' +
			'</div>'+
			'</div>'
	}
};
fourToldApp.directive('imageCapture', imageCapture);
function imageCapture () {
    return{
        restrict:'E',
        template:
        '<md-card>'+
        '<md-card-header ng-show="bodyItem.metadata.sectionTitle">'+
            '<md-card-header-text style="padding-left:3%;">'+
                '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>'+
            '</md-card-header-text>'+
            '<md-card-icon-actions>'+
                '<md-button ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle"'+
                    'aria-label="Close">'+
                    '<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
                    '<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg">'+
                    '</md-icon>'+
                '</md-button>'+
            '</md-card-icon-actions>'+
        '</md-card-header>'+
        '<md-card-content class="input-container" ng-show="!bodyItem.metadata.isExpandable">'+
            '<input style="opacity: 0; width: 0; float: left;" name="picture" id="uploadFile" type="text" ng-model="bodyItem.metadata.defaultValue" required>' +
			'<label style="margin-left: 10px" ng-bind-html="bodyItem.label"> </label>'+
			'<img id="imageCapturePreview" ng-show="checkDefault(bodyItem.metadata.defaultValue)" style="width:240px" ng-src="../images/iconsChat/avatar.png" ng-click="modalImageCapture($index)"/>'+
			'<img id="imageDefault" ng-show="!checkDefault(bodyItem.metadata.defaultValue)"  style="width:240px" ng-src="{{parseImageJsonUrl(bodyItem.metadata.defaultValue)}}"/>' +
            '<md-input-container class="md-block">'+                   
                '<md-button ng-show="checkDefault(bodyItem.metadata.defaultValue)" height="100" width="100"   aria-label="Play" target="_blank" ng-click="modalImageCapture($index)"  >'+
                    '<img height="100" width="100" ng-src="../images/iconsChat/camera.png"/>'+
                '</md-button>'+  
            '</md-input-container>'+
        '</md-card-content>'+
        '</md->'
    }
};
fourToldApp.directive('audioCapture', audioCapture);
function audioCapture (esb, $sce) {
    return{
        restrict:'E',
		link: function(scope){
            scope.detailsInfo = [];
            scope.showInfo = function(expandible, index) {
                actions.click(scope.detailsInfo, expandible, index);
            };
            scope.getAudioSrc = function(bodyItem) {
                if(bodyItem.metadata.defaultValue != '') {
                    scope.hasAudio = true;
                    return  esb + "/security" + bodyItem.metadata.defaultValue;
                } else {
                    scope.hasAudio = false;
                    return "";
                }
            }; 
        },
        template:
		'<div style="display: flex; flex-direction: column;align-items: center;">' + 
		'<div ng-show="generatingSignature" style="box-shadow: #ededed 2px 2px; position: absolute;  width: 50%; height: 40%; background: white; z-index: 5; border-radius: 30px; display: flex; flex-direction: column;align-items: center;">' + 
			'<img style="width: 100px; height: 100px; background: white; border: 0px" ng-src="../images/icons/generating.png"/>' +	
			'<p style="font-size:18px; color:black; text-align: center;">Generando firma</p>' +
		'</div>' + 
		'<input ng-model="bodyItem.metadata.defaultValue" style="display:none" required>'+
        '<md-card style="width: 100%;z-index: 1;">' +
        '<md-card-header ng-show="bodyItem.metadata.sectionTitle">'+
            '<md-card-header-text style="padding-left:3%;">'+
                '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>'+
            '</md-card-header-text>' +
            '<md-card-icon-actions>' +
                '<md-button ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle"'+
                    'aria-label="Close">'+
                    '<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
                    '<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg">'+
                    '</md-icon>'+
                '</md-button>'+
            '</md-card-icon-actions>'+
        '</md-card-header>'+

        '<md-card-content class="input-container" ng-show="!bodyItem.metadata.isExpandable">'+				
           
			'<label style="margin-left: 10px" ng-bind-html="bodyItem.label"> </label>'+		 
       
        '</md-card-content>'+
        '</md-card >' +
		'<div  style="width: 60%; z-index: 2; margin-top:-18px; margin-bottom:-18px">' +		
			'<div style="background: #dddddd;font-weight: bold;font-size: 17px; border-radius: 30px; height: 40px; display: flex; justify-content: center; align-items: center; text-align: center; ">' + 
				'Toca el botón de grabar y lee el texto.'+
			'</div>'+	
		'</div>' + 

        '<md-card style="width: 100%;  height: 150px; z-index: 1;">' +
        '<md-card-header ng-show="bodyItem.metadata.sectionTitle">' +
            '<md-card-header-text style="padding-left:3%;">' +
                '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>' +
            '</md-card-header-text>'+
            '<md-card-icon-actions>'+
                '<md-button ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle"'+
                    'aria-label="Close">'+
                    '<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
                    '<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg">'+
                    '</md-icon>'+
                '</md-button>'+
            '</md-card-icon-actions>'+
        '</md-card-header>'+  
		 
        '<md-card-content class="input-container" ng-show="!bodyItem.metadata.isExpandable">'+			
            
			'<div style="display:flex; justify-content: center; margin-top:3%">'+
				'<audio  ng-src="{{getAudioSrc(bodyItem)}}" id="audioCapturePreview" controls  style="width:240px; display:none"><img class="circulo-img" ng-src="../images/icons/{{iconRecord}}.png"/></audio>'+            
				'<div class="audio_content" style="background: #ebebec;font-weight: bold;font-size: 17px; border-radius: 40px; height: 70px; display: flex; justify-content: flex-start; align-items: center; text-align: center; ">' + 
					'<img ng-show="!isReadyToPlay" style="margin-left: 20px; width: 28px; height: 38px; background: #ebebec; border: 0px" ng-src="../images/icons/{{iconMic}}.png"/>' +	
					'<img ng-click="startPlayAudio()" ng-show="isReadyToPlay && !isPlaying" style="margin-left: 20px; width: 38px; height: 38px; background: #ebebec; border: 0px" ng-src="../images/icons/{{iconPlay}}.png"/>' +	
					'<img ng-click="pausePlayAudio()" ng-show="isReadyToPlay && isPlaying" style="margin-left: 20px; width: 38px; height: 38px; background: #ebebec; border: 0px" ng-src="../images/icons/{{iconPlay}}.png"/>' +	
					'<div  style="margin-left:10px;padding-top:2%;">' +
                          '<p style="text-align: center; color: black; size: 12px;font-weight: normal;" >{{clock}}</p>' +
                    '</div>' +
					'<canvas class="audio_canvas" id="canvasAudio" style="margin-left:10px; height: 80%; background: #ebebec; "></canvas>' +  
					'<img ng-click="reload()"  ng-show="isReadyToPlay" style="margin-right: 11px; margin-left: 5px; width: 40px; height: 40px;  border: 0px" ng-src="../images/icons/{{iconDelete}}.png"/>' +	

				'</div>' +
				'<div>' + 
					'<button style="margin-left:5px; border: 0px solid black; background:white;" aria-label="Play" target="_blank" ng-click="startRecord($index)"  >' +
						'<img class="circulo-img" ng-src="../images/icons/{{iconRecord}}.png"/>' +
					'</button>' + 
					'<p style="font-size:10px; color:{{textRecordColor}}; text-align: center;">{{textRecord}}</p>' +
				'</div>' +
			'</div>'+
        '</md-card-content>'+
        '</md-card>'+
		'</div>' 
    }
};
fourToldApp.directive('audioInfo', audioInfo);
function audioInfo () {
    return{
        restrict:'E',
        template:
        '<md-card>'+
        '<md-card-header ng-show="bodyItem.metadata.sectionTitle">'+
            '<md-card-header-text style="padding-left:3%;">'+
                '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>'+
            '</md-card-header-text>'+
            '<md-card-icon-actions>'+
                '<md-button ng-click="showInfo(bodyItem.metadata)" class="md-icon-button" aria-label="toggle"'+
                    'aria-label="Close">'+
                    '<md-icon ng-show="detailsInfo" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>'+
                    '<md-icon ng-show="!detailsInfo" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg">'+
                    '</md-icon>'+
                '</md-button>'+
            '</md-card-icon-actions>'+
        '</md-card-header>'+
        '<md-card-content class="input-container" ng-show="!bodyItem.metadata.isExpandable">'+
            '<label style="margin-left: 10px" ng-bind-html="bodyItem.label"> </label>'+
            '<md-input-container class="md-block" ng-init="initAudioListener()">'+
                '<audio style="display:none"  id="player"  ng-src="{{getAudioUrl(bodyItem.metadata.constraints)}}" controls></audio>'+   
                '<md-button   height="40" width="40"   aria-label="Play" target="_blank" ng-click="togglePause()"  >'+
                    '<img height="40" width="40" ng-src="../images/icons/{{iconPlay}}"/>'+
                '</md-button>'+                
                '<md-button  height="40" width="40"   aria-label="Stop" target="_blank" ng-click="stopAudio()"  >'+
                    '<img height="40" width="40"  ng-src="../images/icons/stoponn.png"/>'+
                '</md-button>'+
            '</md-input-container>'+
        '</md-card-content>'+
        '</md->'
    }
};

fourToldApp.directive('stringInputForm', stringInputForm);
function stringInputForm () {
    return{
        restrict:'E',
        template:
        '<div class="form-group">'+		
		'<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
        '<input type="text" ng-if="bodyItem.metadata.constraints.maxSize<=250" name="string{{$index}}" id="string{{$index}}" placeholder="escriba aquí" class="form-control input-md" ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField" minlength="{{bodyItem.metadata.constraints.minSize}}" ' +
        'maxlength="{{bodyItem.metadata.constraints.maxSize}}"' +
                ' ng-model="bodyItem.metadata.defaultValue" required>' + 
        '<textarea ng-if="bodyItem.metadata.constraints.maxSize>250" name="string{{$index}}" id="string{{$index}}"  placeholder="escriba aquí" class="form-control input-md"  ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField" ng-model="bodyItem.metadata.defaultValue" minlength="{{bodyItem.metadata.constraints.minSize}}" maxlength="{{bodyItem.metadata.constraints.maxSize}}" required></textarea>' +
		'       <div ng-messages="notificationForm[\'string\' + $index].$error" class="text-color-message" role="alert">'+
		'           <div ng-message="required">Obligatorio</div>'+
        '           <div ng-message="minlength">Mínimo {{bodyItem.metadata.constraints.minSize}} letras o caracteres</div>'+
        '           <div ng-message="maxlength">Máximo {{bodyItem.metadata.constraints.maxSize}} letras o caracteres</div>'+
        '       </div>' +
		'</div>'+
		'</div>'
		
		
       
    }
    
};

fourToldApp.directive('listInputForm', listInputForm);
function listInputForm () {
    return {
        restrict:'E',
        template:
		'<div class="form-group">'+
        '<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
        '<input placeholder="Seleccione una o mas opciones" class="form-control input-md" ng-readonly="true" ng-click="listCheckbox($event, bodyItem.metadata, $index)"   aria-label="bodyItem.targetField" minlength="{{bodyItem.metadata.constraints.minSize}}" ' +        
			' ng-model="bodyItem.metadata.defaultText"  required>' + 
		'<input placeholder="aqui va respuestas"  class="form-control input-md"  ng-readonly="true" name="list{{$index}}" id="list{{$index}}" aria-label="bodyItem.targetField" minlength="{{bodyItem.metadata.constraints.minSize}}" ' +
        ' ng-model="bodyItem.metadata.defaultValue" ng-show="false" class="ng-hide" required>' + 
		'	<div ng-messages="notificationForm[\'list\' + $index].$error" class="text-color-message" role="alert">'+
		'		<div ng-message="required">Obligatorio</div>'+
        '       <div ng-message="minlength">Mínimo {{bodyItem.metadata.constraints.minSize}} letras o caracteres</div>'+
        '       <div ng-message="maxlength">Máximo {{bodyItem.metadata.constraints.maxSize}} letras o caracteres</div>'+
        '	</div>' +
        '</div>'+
        '</div>'       
    }    
};

fourToldApp.directive('numberInputForm', numberInputForm);
function numberInputForm () {
    return{
        restrict:'E',
        template:
          
        '<div class="form-group">'+
        '<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
			'<input ng-if="!bodyItem.metadata.constraints.currencyMask" name="double{{$index}}" id="double{{$index}}" ui-money-mask="bodyItem.metadata.constraints.precision" currency-symbol="" ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField"  placeholder="escriba aquí" class="form-control input-md" type="text" min="{{bodyItem.metadata.constraints.min}}" ' +
        	'max="{{bodyItem.metadata.constraints.max}}" ng-keydown="($event.keyCode===109 || $event.keyCode===38 || $event.keyCode===40 || $event.keyCode===189 ||  $event.keyCode===179 || $event.keyCode === 69) && $event.preventDefault();"   ng-model="bodyItem.metadata.defaultValue" required>' +	
			'<input ng-if="bodyItem.metadata.constraints.currencyMask" name="double{{$index}}" id="double{{$index}}" ui-currency-after ui-money-mask="bodyItem.metadata.constraints.precision" ui-prefix="{{bodyItem.metadata.constraints.currencyMask.prefixCurrency}}" currency-symbol="{{bodyItem.metadata.constraints.currencyMask.suffixCurrency}}" ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField"  placeholder="escriba aquí" class="form-control input-md" type="text" min="{{bodyItem.metadata.constraints.min}}" ' +
        	'max="{{bodyItem.metadata.constraints.max}}" ng-keydown="($event.keyCode===109 || $event.keyCode===38 || $event.keyCode===40 || $event.keyCode===189 ||  $event.keyCode===179 || $event.keyCode === 69) && $event.preventDefault();"   ng-model="bodyItem.metadata.defaultValue" required>' +
		'	<div ng-messages="notificationForm[\'double\' + $index].$error" class="text-color-message" role="alert">'+
		'   	<div ng-message="required">Obligatorio</div>'+
        '      	<div ng-message="min">El valor mínimo es {{bodyItem.metadata.constraints.min}}</div>'+
        '       <div ng-message="max">El valor máximo es {{bodyItem.metadata.constraints.max}}</div>'+
        '	</div>' +
        '</div>'+
		'</div>'
    }
};

fourToldApp.directive('phoneInputForm', phoneInputForm);
function phoneInputForm () {
    return{
        restrict:'E',
        template:
          
        '<div class="form-group">'+
        '<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
        '<input ng-readonly="{{readOnlyForm}}" name="phone{{$index}}" id="phone{{$index}}" aria-label="bodyItem.targetField" class="form-control input-md" type="tel"' +
        'max="{{bodyItem.metadata.constraints.max}}" ng-keydown="($event.keyCode===109 || $event.keyCode===38 || $event.keyCode===40 || $event.keyCode===189 ||  $event.keyCode===179 || $event.keyCode === 69) && $event.preventDefault();" ng-model="bodyItem.metadata.defaultValue" required>' +
        '	<div ng-messages="notificationForm[\'phone\' + $index].$error" class="text-color-message" role="alert">'+
		'   	<div ng-message="required">Obligatorio</div>'+
        '      	<div ng-message="min">Mínimo {{bodyItem.metadata.constraints.min}} números</div>'+
        '       <div ng-message="max">Máximo {{bodyItem.metadata.constraints.max}} números</div>'+
        '	</div>' +
		'</div>'+
        '</div>'        
    }
};


fourToldApp.directive('dateInputForm', dateInputForm);
function dateInputForm () {
    return{
        restrict:'E',
        template:
      
        
 '<div class="form-group">'+
 '<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
 '<div class="col-md-7" >'+ 
       '<div  ng-init="defaultDate($index, bodyItem.metadata.defaultValue, bodyItem.metadata.constraints.maxDate); setConstraints($index, bodyItem.metadata.constraints.minDate, bodyItem.metadata.constraints.maxDate)">' +
         '<p class="input-group">' +
             '<input aria-label="bodyItem.targetField" type="string" name="date{{$index}}" id="date{{$index}}"' +
             'ng-model="bodyItem.metadata.defaultValue" ng-readonly="{{readOnlyForm}}" type="text" class="form-control"' +
             'uib-datepicker-popup="{{format}}" ng-change="setDate($index,bodyItem.metadata.defaultValue)" is-open="bodyItem.opened"' +
             'datepicker-options="bodyItem.metadata.dateOptions"' +
             'close-text="Close" required/>' +
             '<span class="input-group-btn">' +
                 '<button style="background-color: rgb(21,162,134)" ng-disabled="{{readOnlyForm}}" type="button" class="btn btn-default" ng-click="open(bodyItem)">' +
                     '<i style="font-size: 15px; color: white" class="material-icons">perm_contact_calendar</i>' +
                 '</button>' +
             '</span>' +
         '</p>' +
		'	<div ng-messages="notificationForm[\'date\' + $index].$error" class="text-color-message" role="alert">'+
		'       <div ng-message="required">Debe seleccionar o ingresar una fecha válida</div>'+
        '       <div ng-message-exp="[\'date\']">Utiliza un formato que coincida con el solicitado DD-MM-AAAA</div>'+
        '	</div>' +
     '</div>' +
 '</div>'+
 '</div>'
    }
};

fourToldApp.directive('selectInputForm', selectInputForm);
function selectInputForm () {
    return{
        restrict:'E',
        template:
        '<div class="form-group">'+ 
        	'<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7" >'+ 
        '<div ng-if="bodyItem.metadata.images.length===1" class="row" ng-repeat="image in bodyItem.metadata.images" align="left" style="margin-top: 20px; margin-bottom: 20px">' +
        '<img ng-src="{{esb}}/security{{image.url}}" class="col-xs-offset-1 col-xs-12 col-sm-offset-0" style="max-width: 270px; ">' +
        '</div>' +
        '<div ng-if="bodyItem.metadata.images.length>1" layout="row" layout-align="start center"' +
        ' layout-align="center center" class="scrollbar-default"  style="padding-bottom: 10px; overflow-x: auto" >' +
        '<div id="imageModal" class="image-modal" ng-click="closeModal();  $event.stopPropagation();">' +
        '  <span class="close-modal" ng-click="closeModal()">&times;</span>' +
        '  <img class="modal-content" id="zoomedImage" >' +
        '</div>' +
        '<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url!==null" style="margin-left: 20px">' +
        '<img ng-click="imagePreview(image.url)" ng-src="{{esb}}/security{{image.url}}" style="min-width: 270px; max-width: 270px; ">' +
        '</span>' +
        '<span ng-repeat="image in bodyItem.metadata.images" ng-if="image.url===null" style="margin-left: 20px">' +
        '<img ng-src="images/default-profile-image.png" style="min-width: 270px; max-width: 270px; ">' +
        '</span>' +
        ' </div>' +
        '<hr ng-if="bodyItem.metadata.images.length>1 || bodyItem.metadata.images.length===1">' +
		'       <select class="form-control" re ng-model="bodyItem.metadata.defaultValue" ng-options="option.id as option.value for option in bodyItem.metadata.constraints.options" name="selectbasic{{$index}}" id="selectbasic{{$index}}" class="border-select"  aria-label="dinamic_select" ng-disabled="{{readOnlyForm}}" required>'+
        '       </select>'+
		'       <div ng-messages="notificationForm[\'selectbasic\' + $index].$error" class="text-color-message" role="alert">'+
        '           <div ng-message="required">Obligatorio</div>'+
        '       </div>' +
        '</div>'+
 '</div>'
        
    }
};

fourToldApp.directive('externaldataSelectInputForm', externaldataSelectInputForm);
function externaldataSelectInputForm () {
	return {
		restrict: 'E',
		scope:{
			bodyItem: '=',
			notificationform: '=',
			index: '@',
			error: '='
		},
		controller: 'externalDataCntrl',
		template:


			'<div   class="form-group compress-desin-group">' +
			'   <label for="inputNameLabel" class="col-sm-12 col-md-5 control-label compress-desing" ng-bind-html="bodyItem.label"></label>' +
			'   <div class="col-sm-12 col-md-7 dropup">' +
			'   <input required class="form-control" id="autocompleted{{index}}" name="autocompleted{{index}}" ng-readonly="read" ng-model="bodyItem.metadata.defaultText" ng-model-options="{ debounce: 500 }" ng-change="querySearch(bodyItem.metadata.defaultText, bodyItem.metadata.constraints, index)" autocomplete="off" placeholder="Buscar..." type="text" >'+



			'   <div ng-messages="notificationform[\'autocompleted\' + index].$error" style="color:maroon" role="alert">'+
			'       <div ng-message="required"><span ng-if="!bodyItem.metadata.constraints.required">Introduzca un valor para este campo</span><span>{{bodyItem.metadata.constraints.required}}</span></div>'+
			'   </div>' +
			'   </div>' +




			'   <ul ng-show="!selectedItem  && showListText"  id="ulAutocomplete{{index}}" class="dropup-content">'+
			'   <li ng-repeat="data in request"><a href="" ng-click="selectOption(data)">{{data.fullName}}</a></li>'+
			'   </ul>'
	}
};

fourToldApp.directive('regex', regex); 
function regex () {
    return{
        restrict:'E',
		link: function(scope){
			console.log(scope.notificationForm);
		},
        template:
       
         '<div class="form-group"  ng-init="typeRegex(bodyItem.metadata.constraints.regex)">'+		
		'<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
        '<input   ng-pattern="expReg" ng-if="bodyItem.metadata.constraints.maxSize<=250" placeholder="escriba aquí" class="form-control input-md" ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField" minlength="{{bodyItem.metadata.constraints.minSize}}" ' +
        'maxlength="{{bodyItem.metadata.constraints.maxSize}}" type="text" ' +
                ' ng-model="bodyItem.metadata.defaultValue" required>' + 
        '<textarea  ng-pattern="expReg" ng-if="bodyItem.metadata.constraints.maxSize>250" placeholder="escriba aquí" class="form-control input-md"  ng-readonly="{{readOnlyForm}}" aria-label="bodyItem.targetField" ng-model="bodyItem.metadata.defaultValue" minlength="{{bodyItem.metadata.constraints.minSize}}" maxlength="{{bodyItem.metadata.constraints.maxSize}}" required></textarea>' +
        '</div>'+
		'</div>'
		
		
       
    }
    
};

fourToldApp.directive('dynamicForm', dynamicForm);

function dynamicForm() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-12 col-md-12" align="center">' +
            '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat"  style="margin-top: 26px" ng-click="openDynamicForm($event)">' +
            'Dar información' +
            '</md-button>' +
            '</div>'
    }
};

fourToldApp.directive('lifeproofForm', lifeproofForm);

function lifeproofForm() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-12 col-md-12" align="center">' +
            '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat"  style="margin-top: 26px" ng-click="openLifeProofForm($event)">' +
            'Empezar prueba' +
            '</md-button>' +
            '</div>'
    }
};

fourToldApp.directive('liveness', liveness);

function liveness() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-12 col-md-12" align="center">' +
            '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat"  style="margin-top: 26px" ng-click="openLifeProofFormAws($event)">' +
            'Empezar prueba' +
            '</md-button>' +
            '</div>'
    }
};

fourToldApp.directive('passwordForm', passwordForm);

function passwordForm() {
    return {
        restrict: 'E',
        template: '<div class="col-xs-12 col-md-12" align="center">' +
            '<md-button class="chatButton md-block" ng-style="theme.button_selection_chat"  style="margin-top: 26px" ng-click="openPasswordForm($event)">' +
            'Dar información' +
            '</md-button>' +
            '</div>'
    }
};

fourToldApp.directive('fileInput', fileInput);
function fileInput(){
    return{
        restrict:'E',
        template:
        '<md-content ng-show="detailsInfo">' +
        '<label  style="margin-left: 10px" ng-bind-html="bodyItem.label"></label>' +
        '<div class="row" align="center" style="margin-top: 20px; margin-bottom: 20px">' +
        '<div ng-disabled="{{read}}" class="md-button chatButton md-block">' +
        '<label for="fileInput{{$index}}" style="font-weight: normal;">Seleccionar Archivo</label>' +
        '<!--input type="file" id="fileInput" ng-disabled="read"  class="inputfile" options="{maxSize:{{bodyItem.metadata.constraints.maxSize}},extension:\'{{bodyItem.metadata.constraints.extension}}\',fileName:\'{{bodyItem.metadata.constraints.fileName}}\'}" nv-file-select uploader="uploader" filters=""-->' +
        '<input type="file" id="fileInput{{$index}}" ng-disabled="{{read}}" accept=".{{bodyItem.metadata.constraints.extension}}" class="inputfile" options="{maxSize:{{bodyItem.metadata.constraints.maxSize}},extension:\'{{bodyItem.metadata.constraints.extension}}\',fileName:\'{{bodyItem.metadata.constraints.fileName}}\'}" nv-file-select uploader="uploader[$index]" filters=""><!--FILTERS TO BE APPLIED!!!-->' +
        '</div>' +
        '<div ng-repeat="item in uploader[$index].queue" align="center">' +
        '<b>Archivo Seleccionado:</b> {{item.file.name}}' +
        '<span class="btn btn-danger btn-xs" style="margin-left: 5px" ng-click="item.remove()">' +
        '<span class="glyphicon glyphicon-trash"></span>' +
        '</span><br/>' +
        '</div>' +
        '</div>' +
        '</md-card-content>'
    }
}
 
fourToldApp.directive('documentInputForm', documentInputForm);
function documentInputForm () {
    return{
        restrict:'E',
        template:
        '<div class="form-group" ng-init="initItem(bodyItem)">'+		
			'<div>'+
				'<img ng-if="!docsImage[bodyItem.targetField]" class="contentTitle" data-ng-src="images/iconsChat/nonline.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+
				'<img ng-if="docsImage[bodyItem.targetField]" class="contentTitle" data-ng-src="images/iconsChat/check_icon.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+
				'<label class="control-label" style="display: inline-block; text-align: left;  margin-left: 10px; font-size: 18pt; font-weight: normal; color: #1077bd;" ng-bind-html="bodyItem.metadata.constraints.title"></label>' +
				'</div>'+
				'<label class="control-label" style="display: block;text-align: left;" ng-bind-html="getMandatory(bodyItem.metadata.constraints.data)"></label>' +
			'<div>'+ 
        '<document-item-form></document-item-form>' + 
        '</div>'+
		'</div>'  
    }
	};

 
fourToldApp.directive('itemChatMenu', function($sce){
	return {
		restrict: 'E',
		scope: {
			name: '=',
			message: "=",
			hour:"=",
			tag: "@?",
			item: '=',
			selectMenuItem: '='
		},
	
		link: function(scope, element, attrs) {
			scope.renderHtml = function(message) {
				if(message){
					var text = message.replace(/<br\s*\/?>/mg, "\n");
					text = text.replace("<br/>", " ");
					return $sce.trustAsHtml(text);
				}
			}
			if(scope.name === undefined)
				scope.name = "Hola Prestamo"
		},
        template:
		'		<h3>'+
		'		  <span class="default-name-item-chat cortar" ng-class="{selectedIndexTextColor: selectMenuItem===\'item-0\'}">'+
		'			{{tag}}{{name}}'+
		'		  </span>'+
		'		</h3>'+
		'       <span ng-if="item.unread > 0" class="md-secondary unreadAlert">{{item.unread}}</span>'+
		'		<!--h4 style="padding-top: 3%;" ng-bind-html="renderHtml(message)"></h4-->'
	}	
});

fourToldApp.directive('avatar', function(){
	var linker = function (scope, element, attrs) {
		if(scope.iconBanner === undefined)
			scope.iconBanner = "images/logo.png";
	};
	return {
		restrict: 'A',
		link: linker
	}	
});
 
		fourToldApp.directive('documentItemForm', documentItemForm);
		function documentItemForm () {
				return{
						restrict:'E',
						template:
						'<div ng-repeat="item in bodyItem.metadata.constraints.data track by $index" >'+			
						'<div>'+
							'<img ng-show="!txtTitleImages[bodyItem.targetField][item.id]" class="contentTitle" data-ng-src="images/iconsChat/notline.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+
							'<img ng-show="txtTitleImages[bodyItem.targetField][item.id]" class="contentTitle" data-ng-src="images/iconsChat/check_icon.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+
							'<label class="control-label" style="display: inline-block; text-align: left;  margin-left: 10px; font-size: 12pt; font-weight: normal; color: #606060;" ng-bind-html="item.title"></label>' +
							'</div>'+							
						'<div>'+ 
						'<md-input-container class="md-icon-float md-block" style="margin-bottom: 0px; margin-top: 10px;">' +
							'<md-icon ng-show="txtImages[bodyItem.targetField][item.id]" md-svg-src="images/icons/done-24px.svg" class="name"></md-icon>' + 
								'<input ng-model="txtFileNames[bodyItem.targetField][item.id]" placeholder="Tomar foto o adjuntar archivo" class="form-control input-md" required ng-readonly="true">' + 	 
								'<md-icon  ng-show="txtImages[bodyItem.targetField][item.id]" href="" ng-click="delete(item, bodyItem);" name="icon2" md-svg-src="images/icons/close.svg"></md-icon>' +
							'</md-input-container>' + 						
						'<div>'+
							'<div style="display: inline-block; width: 60%;" ng-click="dialogReasons(item, bodyItem)">'+									
								'<img ng-show="!item.mandatory && txtImagesSkip[bodyItem.targetField][item.id]" class="contentTitle" data-ng-src="images/iconsChat/skip.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+	
								'<img ng-show="!item.mandatory && !txtImagesSkip[bodyItem.targetField][item.id]" class="contentTitle" data-ng-src="images/iconsChat/noline.png" style="width: 23px; height: 23px; display: inline-block;  vertical-align: sub;" alt="">'+
								'<label class="control-label" style="display: inline-block; text-align: left;  margin-left: 10px; font-size: 14pt; font-weight: normal; color: #606060;"><p ng-show="!item.mandatory">Omitir enviar archivo</p></label>' +
							'</div>'+ 
							'<div style="display: inline-block; width: 30%; text-align: end;">'+								 
								'<img ng-show="item.type!=\'File\'" class="contentTitle" data-ng-src="images/iconsChat/camaraform.png" style="width: 35px; height: 25px; display: inline-block; vertical-align: sub;" alt="" ng-click="uploadImge($event, item, bodyItem)">'+
								'<div ng-show="item.type!=\'Image\'" style="width: 35px; height: 25px; display: inline-block; vertical-align: sub;">'+
								' <a href="" style="min-width: 20px; min-height: 20px; display: inline-block; margin-left: 15px; padding: 0px; margin-top: 0px;"  type="file" aria-label="upload" style="margin-top: 26px" ngf-select="uploadFiles($event, item, bodyItem)"  ng-model="fileToUpload" id="file" name="file" accept="{{getExtensions(item.extension)}}" extension="{{item.extension}}" valid-file ngf-max-size="5MB" ngf-model-invalid="errorFile">' +
								'	<img class="contentTitle" style="width: 35px; margin-top: -12px; height: 25px;" data-ng-src="images/iconsChat/fileattach.PNG" alt="">'+
								' </a>' +
								'</div>' +									
							'</div>'+
						'</div>'+
					'</div>' 
				}		
    
}; 

fourToldApp.directive('tableInput', tableInput); // componente Tabla
function tableInput (actions, $sce, $window) {
		return {
		restrict: 'E',
		scope:{
				bodyItem: '='
		},
		link: function(scope){
			if(scope.bodyItem.metadata.constraints.orientation === "vertical") {
				scope.bodyItem.metadata.constraints.tableConfig.showVertical = true;
		}
				scope.detailsInfo = [];
				scope.showInfo = function(expandible, index) {
						actions.click(scope.detailsInfo, expandible, index);
				};
				
				function isArrayFunction(){
						if(!angular.isArray(scope.bodyItem.metadata.constraints.tableConfig.body)) {
								scope.notArray = true;
						 }
				};
				scope.renderHtml = function(title) {
						if(title){
								var text = title.replace(/<br\s*\/?>/mg, "\n");
								text = text.replace("<br/>", " ");
								return $sce.trustAsHtml(text);
						}
				}
				scope.getIconUrl = function(icon) {
						if(icon){
								return '../'+icon;
						} else {
								return '';
						}
				}
				scope.headerTable = function(data){
						if(data.header){
							var array = data.header.split(",");
							return array
						}
				};
				scope.verticalToggle = function(data){
						data.showVertical = !data.showVertical;
				};
				scope.copyTable = function(data){
						let toCopy = '';
						if (!data || !data.constraints || data.constraints.type != 'Table'){
								return;
						}
						let tableConfig = data.constraints.tableConfig;
						toCopy += tableConfig.header;
						if (angular.isArray(tableConfig.body)){
								tableConfig.body.forEach(row => {
										toCopy += '\n';
										let fc = true; // fc = firstColumn
										for (const [key, value] of Object.entries(row)) {
												if (key.startsWith('$')){
														continue;
												}
												if (!fc){
														toCopy +=',';
												}
												let text = '';
												if (value.type){
														if (value.type === 'icon' && value.tooltip){
																text = value.tooltip;
														} else if(value.type === 'date'){
																text = moment(new Date(value.value)).format('DD/MM/YYYY')
														} else if(value.type === 'datetime'){
																text = moment(new Date(value.value)).format('DD/MM/YYYY HH:mm:ss')
														} else {
																text = value.value;
														}
												} else {
														text = value;
												}
												toCopy += '"'+(text+'').replace(/<br\s*\/?>/mg, "")+'"'
												fc = false;
										}
								});
						}
						var body = angular.element($window.document.body);
						var textarea = angular.element('<textarea/>');
						textarea.css({
								position: 'fixed',
								opacity: '0'
						});
						textarea.val(toCopy);
						body.append(textarea);
						textarea[0].select();
						try {
								var successful = document.execCommand('copy');
								if (!successful) throw successful;
						} catch (err) {
								window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
						}
						textarea.remove();
				};
				isArrayFunction();
		},
		template:  
		'<md-content  style="overflow-x: auto"  ng-if="!bodyItem.metadata.constraints.tableConfig.showVertical">' +		


		'<div ng-if="bodyItem.metadata.sectionTitle">' +
				'<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>' +
				'<md-button  ng-click="showInfo(bodyItem.metadata, $index)" class="md-icon-button" aria-label="toggle" aria-label="Close">' +
				'<md-icon ng-if="detailsInfo[$index]" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>' +
				'<md-icon ng-if="!detailsInfo[$index]" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg"></md-icon>' +
				"</md-button>" +
				'<md-button class="md-icon-button" aria-label="Copiar" ng-click="copyTable(bodyItem.metadata)">' +
				'<md-icon class="material-icons">content_copy</md-icon>' +
				'<md-tooltip md-direction="left">Copiar</md-tooltip>' +
				'</md-button>'+
				'<md-button class="md-icon-button" aria-label="Copiar" ng-click="verticalToggle(bodyItem.metadata.constraints.tableConfig)">' +
				'<md-icon class="material-icons">view_column</md-icon>' +
				'<md-tooltip md-direction="left">Vertical</md-tooltip>' +
				'</md-button>'+
		"</div>" +
		'<div ng-if="!bodyItem.metadata.isExpandable" class="row" style="width: 100%; margin: 0px 0 0 0">' +
				'<label ng-bind-html="bodyItem.label"></label>'+
				'<md-button ng-if="bodyItem.label && bodyItem.label !== \'\'" class="md-icon-button" aria-label="Copiar" ng-click="copyTable(bodyItem.metadata)">' +
						'<md-icon class="material-icons">content_copy</md-icon>' +
						'<md-tooltip md-direction="left">Copiar</md-tooltip>' +
				'</md-button>'+
		'<div class="col-xs-12 col-sm-12" style="padding:0px; display: grid">' +
		'<div class="table-responsive2 tableFixHead">' +
		'<table class="table table-bordered table-striped" style="overflow: auto;">' +
		"<thead>" +
		"<tr>" +
		'<th style="background-color: #51596A !important; color: #f2f2f2; font-weight: bold;" ng-repeat="header in headerTable(bodyItem.metadata.constraints.tableConfig)">{{header}}</th>' +
		"</tr>" +
		"</thead>" +
		"<tbody ng-if='!notArray'>" +
				'<tr ng-repeat="items in bodyItem.metadata.constraints.tableConfig.body">' +
						'<td ng-repeat="item in items track by $index">' +
								"<div ng-style='item.style' ng-if=\"!item.type\" ng-bind-html=renderHtml(item)></div>" +
								"<div ng-style='item.style' ng-if=\"item.type === 'string'\" ng-bind-html=renderHtml(item.value)></div>" +
								"<div ng-style='item.style' ng-if=\"item.type === 'date'\">{{item.value | date:'dd/MM/yyyy':'UTC'}}</div>" +
								"<div ng-style='item.style' ng-if=\"item.type === 'datetime'\">{{item.value | date:'dd/MM/yyyy HH:mm:ss'}}</div>" +
								"<div ng-style='item.style' ng-if=\"item.type === 'money' && item.symbol\">{{item.value | currency: item.symbol}}</div>" +
								'<div ng-style="item.style" ng-if="item.type === \'money\' && !item.symbol">{{item.value | currency: "$"}}</div>' +
								'<div ng-style="item.style" ng-if="item.type === \'icon\'">' +
										'<img ng-src="{{getIconUrl(item.value)}}" style="width:24px; height:24px"/>' +
								'</div>' +
								'<md-tooltip ng-if=\"item.tooltip\" style="font-size:14px;">{{item.tooltip}}</md-tooltip>' +
								'<!--div ng-init="compare(item)">{{itemType}}</div>-->' +
						"</td>" +
				"</tr>" +
		"</tbody>" +
		"<tbody ng-if='notArray'>" +
		"<tr>" +
		"<td colspan='9'>" +
		"Sin información"+
		"</td>" +
		"</tr>" +
		"</tbody>" +
		"</table>" +
		'</div">' +
		"</div>" +
		"</div>" +
		"</md-content>"
		}
};
fourToldApp.directive('tableInputVertical', tableInputVertical); // componente Tabla
function tableInputVertical (actions, $sce, $window) {
    return {
    restrict: 'E',
    scope:{
        bodyItem: '='
    },
    link: function(scope){
        scope.detailsInfo = [];
        scope.showVertical = false;
				scope.headerStyle = "{'width':'10%',  'background-color': '#729FCF', 'color': 'black', 'font-weight': 'bold', 'text-align': 'start'}";
				scope.columStyle = "{'width':'10%', 'text-align': 'start'}";				
				if(bodyItem.metadata.constraints.orientation === "vertical") {
					bodyItem.metadata.constraints.tableConfig.showVertical = true;
				}
				scope.bodyItem.metadata.constraints.tableConfig.styleTable = 'table table-bordered table-striped'; 
            if(scope.bodyItem.metadata.constraints.tableConfig.style === "form") {
							scope.bodyItem.metadata.constraints.tableConfig.showVertical = true;
							scope.bodyItem.metadata.constraints.tableConfig.styleTable = 'table';
							scope.headerStyle = "{'width':'10%', 'color': 'black', 'font-weight': 'bold', 'text-align': 'start', 'border-top': '0px'}";
						  scope.columStyle = "{'width':'10%', 'border-top': '0px', 'text-align': 'start'}";				
            }

			//

        scope.showInfo = function(expandible, index) {
            actions.click(scope.detailsInfo, expandible, index);
        };
        function isArrayFunction(){
            if(!angular.isArray(scope.bodyItem.metadata.constraints.tableConfig.body)) {
                scope.notArray = true;
             }
        };
        scope.next = function(tableConfig){        
            var pages = tableConfig.pages;
            if (tableConfig.currentPage < tableConfig.totalPages){
                tableConfig.currentPage ++;
                tableConfig.subtable = scope.getTableConfig(tableConfig);
            }
        }
        scope.verticalToggle = function(data){
            data.showVertical = !data.showVertical;
        };
        scope.prev = function(tableConfig){        
            if (tableConfig.currentPage > 0){
                tableConfig.currentPage --;
                tableConfig.subtable = scope.getTableConfig(tableConfig);
            }
        }
        scope.getTableConfig = function(tableConfig){
            var currentPage = tableConfig.currentPage;
            var table = tableConfig.table;
            var rows = new Array();
            for(var rs of table) {
                var row = new Array();
                for(var item of rs) {
                    if(item.page === currentPage || item.type ===  "header") {
                        row.push(item);
                    }
                }
                rows.push(row);
            }
            console.log(rows);
            return rows;
        }
        scope.renderHtml = function(title) {
            if(title){
                var text = title.replace(/<br\s*\/?>/mg, "\n");
                text = text.replace("<br/>", " ");
                return $sce.trustAsHtml(text);
            }
        }
        scope.getIconUrl = function(icon) {
            if(icon){
                return '../'+icon;
            } else {
                return '';
            }
        }
        scope.headerTable = function(data){
            if(data.header){
              var array = data.header.split(",");
              return array
            }
        };
        scope.copyTable = function(data){
            let toCopy = '';
            if (!data || !data.constraints || data.constraints.type != 'Table'){
                return;
            }
            let tableConfig = data.constraints.tableConfig;
            toCopy += tableConfig.header;
            if (angular.isArray(tableConfig.body)){
                tableConfig.body.forEach(row => {
                    toCopy += '\n';
                    let fc = true; // fc = firstColumn
                    for (const [key, value] of Object.entries(row)) {
                        if (key.startsWith('$')){
                            continue;
                        }
                        if (!fc){
                            toCopy +=',';
                        }
                        let text = '';
                        if (value.type){
                            if (value.type === 'icon' && value.tooltip){
                                text = value.tooltip;
                            } else if(value.type === 'date'){
                                text = moment(new Date(value.value)).format('DD/MM/YYYY')
                            } else if(value.type === 'datetime'){
                                text = moment(new Date(value.value)).format('DD/MM/YYYY HH:mm:ss')
                            } else {
                                text = value.value;
                            }
                        } else {
                            text = value;
                        }
                        toCopy += '"'+(text+'').replace(/<br\s*\/?>/mg, "")+'"'
                        fc = false;
                    }
                });
            }
            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });
            textarea.val(toCopy);
            body.append(textarea);
            textarea[0].select();
            try {
                var successful = document.execCommand('copy');
                if (!successful) throw successful;
            } catch (err) {
                window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
            }
            textarea.remove();
        };
        isArrayFunction();
    },
    template:  
    '<md-content  style="overflow-x: auto" ng-if="bodyItem.metadata.constraints.tableConfig.showVertical">' +
    
    

    '<div ng-if="bodyItem.metadata.sectionTitle">' +
        '<span class="md-title">{{bodyItem.metadata.sectionTitle}}</span>' +
        '<md-button  ng-click="showInfo(bodyItem.metadata, $index)" class="md-icon-button" aria-label="toggle" aria-label="Close">' +
        '<md-icon ng-if="detailsInfo[$index]" md-svg-src="../images/icons/keyboard_arrow_down.svg"></md-icon>' +
        '<md-icon ng-if="!detailsInfo[$index]" md-svg-src="../images/icons/baseline-keyboard_arrow_up-24px.svg"></md-icon>' +
        "</md-button>" +
        '<md-button class="md-icon-button" aria-label="Copiar" ng-click="copyTable(bodyItem.metadata)">' +
        '<md-icon class="material-icons">content_copy</md-icon>' +
        '<md-tooltip md-direction="left">Copiar</md-tooltip>' +
        '</md-button>'+
				'<md-button class="md-icon-button" aria-label="Copiar" ng-click="verticalToggle(bodyItem.metadata.constraints.tableConfig)">' +
    		'<md-icon class="material-icons">view_list</md-icon>' +
    		'<md-tooltip md-direction="left">Horizontal</md-tooltip>' +
    		'</md-button>'+
    "</div>" +
    '<div ng-if="!bodyItem.metadata.isExpandable" class="row" style="width: 100%; margin: 0px 0 0 0">' +
        '<label ng-bind-html="bodyItem.label"></label>'+
        '<md-button ng-if="bodyItem.label && bodyItem.label !== \'\'" class="md-icon-button" aria-label="Copiar" ng-click="copyTable(bodyItem.metadata)">' +
            '<md-icon class="material-icons">content_copy</md-icon>' +
            '<md-tooltip md-direction="left">Copiar</md-tooltip>' +
        '</md-button>'+ 
    '<div class="col-xs-12 col-sm-12" style="padding:0px; display: grid">' +
    '<div class="table-responsive2 tableFixHead">' +
    '<table ng-class="[bodyItem.metadata.constraints.tableConfig.styleTable]" style="overflow: auto;">' +
    "<thead>" + 
    "</thead>" +
    "<tbody ng-if='!notArray'>" +
        '<tr ng-repeat="rows in bodyItem.metadata.constraints.tableConfig.subtable track by $index" >' + 
            '<td ng-repeat="item in rows"  ng-style="$index ===0 ? {{headerStyle}}: {{columStyle}} ">' +
                "<div ng-if=\"item.type === 'header'\">{{item.value}}</div>" +
                "<div ng-style='item.style' ng-if=\"item.type === 'notype'\" ng-bind-html=renderHtml(item.value)></div>" +
                "<div ng-style='item.style' ng-if=\"item.type === 'string'\" ng-bind-html=renderHtml(item.value)></div>" +
                "<div ng-style='item.style' ng-if=\"item.type === 'date' \">{{item.value | date:'dd/MM/yyyy':'UTC'}}</div>" +
                "<div ng-style='item.style' ng-if=\"item.type === 'datetime' \">{{item.value | date:'dd/MM/yyyy HH:mm:ss'}}</div>" +
                "<div ng-style='item.style' ng-if=\"item.type === 'money' && item.symbol\">{{item.value | currency: item.symbol}}</div>" +
                '<div ng-style="item.style" ng-if="item.type === \'money\' && !item.symbol">{{item.value | currency: "$"}}</div>' +
                '<div ng-style="item.style" ng-if="item.type === \'icon\'">' +
                    '<img ng-src="{{getIconUrl(item.value)}}" style="width:24px; height:24px"/>' +
                '</div>' +
                '<md-tooltip ng-if="item.tooltip" style="font-size:14px;">{{item.tooltip}}</md-tooltip>' +
                '<!--div ng-init="compare(item)">{{itemType}}</div>-->' +
            "</td>" +
        "</tr>" +
       
    "</tbody>" +
    "<tbody ng-if='notArray'>" +
    "<tr>" +
    "<td colspan='9'>" +
    "Sin información"+
    "</td>" +
    "</tr>" +
    "</tbody>" +
    "</table>" +    
    '</div">' +
    "</div>" +
    "</div>" + 
    "</md-content>" +     
    "<table ng-if='bodyItem.metadata.constraints.tableConfig.totalPages > 0' class='table table-bordered table-striped' style='overflow: auto;'><tr><td  colspan='9'>" +    
    '<md-button ng-click="prev(bodyItem.metadata.constraints.tableConfig)" class="md-icon-button" style="width:80px" aria-label="toggle" aria-label="Close">' +  
        '<< Ant' +
        '</md-button>' +
            '<p style="display:inline">Pág {{bodyItem.metadata.constraints.tableConfig.currentPage + 1}} de {{bodyItem.metadata.constraints.tableConfig.totalPages + 1}}</p>' +
            '<md-button  ng-click="next(bodyItem.metadata.constraints.tableConfig)" class="md-icon-button"  style="width:80px" aria-label="toggle" aria-label="Close">' +  
        'Sig >>' +
    '</md-button>' +
    "</td><tr></table>"
    }
};

fourToldApp.directive('imageShowForm', imageShowForm);
function imageShowForm () {
    return{
        restrict:'E',
        template:
          
        '<div class="form-group">'+
        '<label class="col-md-5 control-label" ng-bind-html="bodyItem.label"></label>' +
        '<div class="col-md-7">'+ 
        '<img ng-src={{parseImageJsonUrl(bodyItem.metadata.defaultValue)}}    alt="Description"  style="max-width: 200px;padding-bottom: 10px; padding-top: 10px; border: none" class="thumbnail"/>' +        
        '</div>'+
        '</div>'        
    }
};






